<template>
  <div class="city-new">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="newForm" :model="cityModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="名称" prop="name">
            <Input v-model="cityModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="城市编码" prop="code">
            <Input v-model="cityModel.code" placeholder="输入城市编码(六位)" />
          </FormItem>
          <FormItem label="级别" prop="tier">
            <Select v-model="cityModel.tier" filterable>
              <Option v-for="(tp,idx) in $common.getEnumSelect($common.cityTier)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
            </Select>
          </FormItem>
          <FormItem label="状态" prop="isVisible">
            <i-switch v-model="cityModel.isVisible" size="large">
              <span slot="open">可见</span>
              <span slot="close">隐藏</span>
            </i-switch>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'city-new',
  props: {
  },
  data () {
    return {
      loading: false,
      cityModel: {
        name: null,
        code: null,
        tier: null,
        isVisible: true
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请填写城市编码', trigger: 'blur' }
        ],
        tier: [
          { type: 'number', required: true, message: '请选择城市级别', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.City.addCity(this.cityModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('新增成功!')
              this.cityModel= {
                name: null,
                code: null,
                tier: 3,
                isVisible: true
              }
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
